import { Navigate } from 'react-router-dom';
import { useAuth } from 'src/hooks';
import { premiumPageBlockerPageRoute } from 'src/routes/route-list';

interface Props {
  children: JSX.Element;
}

export const PremiumRequiredPageBlocker = ({ children }: Props) => {
  const { user } = useAuth();

  if (!user || user.role === 'USER') {
    return <Navigate to={premiumPageBlockerPageRoute} />;
  }

  return children;
};
